<template>
  <v-snackbar
    v-model="notification"
    right
    :color="notificationType"
    :timeout="5000"
  >
    <span v-html="notificationText"></span>
    <v-badge
      v-model="badge"
      overlap
      color="error"
    >
      <template v-slot:badge>
        <span>{{ notificationQueue.length }}</span>
      </template>
      <v-btn
        dark
        text
        @click="dismissNotification"
      >
        {{ hasNotificationsPending ? 'Next' : 'Close' }}
      </v-btn>
    </v-badge>
  </v-snackbar>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';

  export default {
    name: 'Notification',
    data() {
      return {
        notificationText: '',
        notificationType: '',
        notification: false,
        badge: false
      }
    },
    computed: {
      ...mapState([
        'notificationQueue',
      ]),
      ...mapGetters([
        'hasNotificationsPending'
      ])
    },
    watch: {
      notification() {
        if (this.notification) {
          this.setNotification();
        }
        if (!this.notification && this.hasNotificationsPending) {
          this.$nextTick(() => this.notification = true);
        }
      },
      notificationQueue() {
        if (!this.notification && this.hasNotificationsPending) {
          this.notification = true;
        }
        this.badge = this.hasNotificationsPending;
      }
    },
    methods: {
      ...mapActions([
        'shiftNotification'
      ]),

      dismissNotification() {
        if (this.hasNotificationsPending) {
          this.setNotification();
        } else {
          this.notification = false;
        }
      },

      async setNotification() {
        const item = await this.shiftNotification();
        this.notificationText = item.text;
        this.notificationType = item.type;
      }
    }
  }
</script>
